export default __webpack_public_path__ + "static/char-s-15-cht-3b55174bff3f315fc0ee610142a1396b.webp";